<template>
    <div class="loader" :class="'loader--' + renderFullscreen">
        <img src="/img/icons/loader.svg" class="" />
        <span v-if="text">Načítavanie...</span>
    </div>
</template>

<script>
export default {
    props: ["text", "fullscreen"],
    computed: {
        renderFullscreen() {
            return this.fullscreen ? "fullscreen" : "";
        },
    },
};
</script>

<style lang="scss" scoped>
.loader {
    max-width: 100%;
    width: 5rem;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;

    &--fullscreen {
        min-height: 50vh;
        flex-direction: column;
    }
}
</style>
